module.exports = __webpack_public_path__ + "img/download.85cd4785.svg";